/**
 * A row of counts at the top of a page.
 *
 * Two per line on a phone, one column each on a desktop. A number only gets a
 * colour when it is asking for something to be done about it — a page where every
 * figure is tinted is a page where none of them mean anything.
 *
 * The column count is spelled out rather than computed, because Tailwind scans for
 * literal class names and a template string would produce nothing.
 */

const COLUMNS = {
    2: "sm:grid-cols-2",
    3: "sm:grid-cols-3",
    4: "sm:grid-cols-4",
    5: "sm:grid-cols-5",
    6: "sm:grid-cols-3 lg:grid-cols-6"
};

const TONES = {
    amber: "text-amber-600 dark:text-amber-400",
    red: "text-red-600 dark:text-red-400",
    green: "text-emerald-600 dark:text-emerald-400"
};

export function StatSummary({ stats }) {
    return (
        <div className={`card grid grid-cols-2 divide-x divide-y divide-gray-100 sm:divide-y-0 dark:divide-gray-800 ${COLUMNS[stats.length] ?? "sm:grid-cols-4"}`}>
            {stats.map((stat) => (
                <div key={stat.label} className="min-w-0 px-4 py-3">
                    <p className="muted truncate text-xs">{stat.label}</p>
                    <p className={`mt-0.5 text-xl font-semibold tabular-nums ${TONES[stat.tone] ?? ""}`}>{stat.value}</p>
                </div>
            ))}
        </div>
    );
}
